
import './App.css';
import './configs/muiProLicense';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { RouterProvider } from 'react-router-dom';

import router from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider
        maxSnack={2}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <RouterProvider router={router} />
      </SnackbarProvider>
    </QueryClientProvider>
  );
}

export default App;
